<template>
  <div>
    <kst-input load-on-focus field="IsAutoNumber" :data="userData" :catalog="Catalog">
      <template #right>
        <kst-input addons expanded field-only
          v-show="!userData.IsAutoNumber"
          field="ExpenseNumber" :data="userData" :catalog="Catalog"
          :customValidations="numberValidations"
        />
      </template>
    </kst-input>
    <kst-input load-on-focus field="Date" :data="userData" :catalog="Catalog"/>
    <kst-input field="SubCategoryID" :options="categoryOption" :data="userData" :catalog="Catalog"/>
    <kst-input field="Total" :data="userData" :catalog="Catalog"/>
    <kst-input field="Comment" :data="userData" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../ExpenseCatalog.js";
import Model from "../ExpenseModel.js";

export default {
  props: {
    userData: Object,
    categoryOption: Object
  },
  data: () => ({
    Catalog: Catalog,
    Model: Model
  }),
  computed: {
    numberValidations() {
      return Model.validationNumber(this.userData);
    }
  }
}
</script>